export default __webpack_public_path__ + "static/media/christmas.0367da05.gif";